import { FilterPanelBaseFilter } from "./BaseFilter";

type SwitchFilterModelDeps = {
    readonly label: string;
    /** Whether the switch reads as on before the user touches it. Defaults to off. */
    readonly initialDtoValue?: boolean;
};

export class SwitchFilterModel extends FilterPanelBaseFilter<boolean> {
    readonly label: string;

    constructor({ label, initialDtoValue }: SwitchFilterModelDeps) {
        super({ options: [], initialDtoValue });

        this.label = label;
    }

    fromApiValue(value?: boolean): boolean {
        return value ?? this.initialDtoValue ?? false;
    }

    /**
     * Turning a switch off normally just drops it from the payload. A default-on switch cannot do that —
     * an absent key already reads as on — so it has to say `false` out loud.
     */
    toApiValue(value?: boolean): boolean | undefined {
        if (value) {
            return true;
        }

        return this.initialDtoValue ? false : undefined;
    }

    /**
     * An absent value means "untouched", which reads as the default — not as `false`. Both sides go through
     * `fromApiValue` so a default-on switch is clean until it is actually turned off.
     */
    isFilterDirty(currentValue?: boolean): boolean {
        return this.fromApiValue(currentValue) !== this.fromApiValue(this.initialDtoValue);
    }
}
